export const VISUALIZER_MANAGEMENT_ACTIONS = {
  getState: "getState",
  checkState: "checkState",
  setState: "setState",
  visualizerIsLoaded: "visualizerIsLoaded",
  closeVisualizerNavigation: "closeVisualizerNavigation",
  visualizerIsSaved: "visualizerIsSaved",
}
